export default function MainContent ({ children }) {

    return (
        <div className="flex flex-col lg:flex-row flex-nowrap w-full max-w-full grow">
           { children }
        </div>
    )
}